import { render, staticRenderFns } from "./order-details.vue?vue&type=template&id=6fc4d963&scoped=true"
import script from "./order-details.vue?vue&type=script&lang=js"
export * from "./order-details.vue?vue&type=script&lang=js"
import style0 from "./order-details.vue?vue&type=style&index=0&id=6fc4d963&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc4d963",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fc4d963')) {
      api.createRecord('6fc4d963', component.options)
    } else {
      api.reload('6fc4d963', component.options)
    }
    module.hot.accept("./order-details.vue?vue&type=template&id=6fc4d963&scoped=true", function () {
      api.rerender('6fc4d963', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/order-details.vue"
export default component.exports